<script>
import LandingPageMixin from '@/mixins/landingpage'

import { SELLING_REGIONS } from '@/constants'

// isMenuToggle: toggleMenu()
// isModalToggle: toggleModal()
// showCover: toggleCover()

export default {
  name: 'LandingPageLuxuryGold',
  mixins: [ LandingPageMixin ],
  data () {
    return {
      isModalTermsAndConditionsToggle: false,
      isModalBookMyGroupToggle: false,
      constants: {
        SELLING_REGIONS
      }
    }
  },
  methods: {
    toggleTermsAndConditionsModal () {
      this.isModalTermsAndConditionsToggle = !this.isModalTermsAndConditionsToggle
      document.body.classList.toggle('modal-open', this.isModalTermsAndConditionsToggle)
    },
    scrollMeTo (refName) {
      var element = document.getElementById(refName)
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      })
    },
    scrollMeDay (dd) {
      var element = document.getElementById(dd)
      var modal = document.getElementById('modal-fullscreen')
      modal.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth'
      })
    }
  }
}

</script>

<style lang="scss" scoped>
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
</style>
<template>
  <div id="menu" class="body-page fp-viewing-home body" :class="{ 'modal-open': isModalToggle }">
    <!-- BEGIN OF site header Menu -->
    <header class="page-header navbar page-header-drawer menu-right logo-left topmenu-right animated slow fadeIn">

      <!-- Begin of menu icon toggler -->
      <button class="navbar-toggler site-menu-icon" id="navMenuIcon" :class="{ 'menu-visible': isMenuToggle }" @click="toggleMenu">
        <span class="menu-icon menu-icon-line" :class="{ 'menu-visible': isMenuToggle }">
          <span class="text show-menu-visible" :class="{ 'menu-visible': isMenuToggle }">Close</span>
          <span class="text hide-menu-visible" :class="{ 'menu-visible': isMenuToggle }">Menu</span>
          <span class="bars">
            <span class="bar1"></span>
            <span class="bar2"></span>
            <span class="bar3"></span>
          </span>
        </span>
      </button>

      <div class="cover-tittle">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id" class="light-logo" src="/landingpages/luxury-gold/img/logo.png" alt="Logo">
              <img v-else class="light-logo" src="/landingpages/luxury-gold/img/logo.png" alt="Logo">
            </span>
          </a>
        </div>
      </div>

      <div class="all-menu-wrapper" id="navbarMenu" :class="{ 'menu-visible': isMenuToggle }">
        <nav class="navbar-mainmenu">
          <div class="mainmenu-bg" @click="toggleMenu"></div>
          <div class="mainmenu-content">
            <ul class="navbar-nav">
              <li class="nav-item active">
                <a class="nav-link" href="#introduction" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('introduction')">Introduction<span class="sr-only">(current)</span></a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#itinerary" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('itinerary')">Itinerary</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#inclusion" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('inclusion')">Inclusions</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#map" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('map')">Map</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#prices" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('prices')">Pricing</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#contact" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('contact')">Contact Us</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <!-- END OF site header Menu-->

    <!-- BEGIN OF page main content -->
    <main class="page-main main-anim main-parallax scrollpage-container animated fadeIn" id="mainpage">

      <div class="page-cover scrolled">
        <!-- Cover Background -->
        <div class="cover-bg bg-img" :style="[firstOpporunityBackgroundImage != ''
            ? {
                backgroundImage: `url('${getParsedImageUrl(
                  firstOpporunityBackgroundImage
                )}')`
            } : {'background-image': 'url(/landingpages/luxury-gold/img/bg-style-1.jpg)'}]">
        </div>
        <div class="cover-bg-mask bg-color">
        </div>
      </div>

      <div
        id="home"
        class="backgroundHome section section-home fullscreen-md main-home section-center content-black "
        data-section="home">
        <div class="section-wrapper animated delay-1s slow fadeIn">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
              <!--This is Home-->
                <div class="cover-header-description text-shadow-all">
                  <div class="cover-slider-description">
                    <h1 class="cover-header-description-title1">
                      <i class="icon fa fa-calendar"></i>
                      <span v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                      <i class="fa fa-arrow-right ml-2"></i>
                      <i class="icon fa fa-calendar"></i>
                      <span v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}</span>
                      <span class="ml-5" v-if="Array.isArray(d.itineraries.locations_visited) == true">
                        <i class="fa fa-map-marker" ></i>
                        <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}</span>
                      </span>
                    </h1>
                    <div class="cover-header-description-title2" v-if="d && d.consumer_section">
                      {{ d.consumer_section.trip_name }}
                    </div>
                    <div class="cover-header-description-title3" v-if="d && d.consumer_section">
                        <span>{{ d.consumer_section.trip_subtitle }}</span>
                    </div>
                    <a  @click="scrollMeTo('introduction')"><span class="icon-arrow-down"></span></a>
                  </div>
                </div>
              <!--Finish Home-->
              </div>

            </div>
          </div>

          <footer class="section-footer scrolldown">
            <a class="down" @click="scrollMeTo('introduction')">
              <span class="icon"></span>
              <span class="txt">INTRODUCTION</span>
            </a>
          </footer>
        </div>
      </div>

      <!-- Begin of grid list section -->
      <div class="section fl-porto text-shadow-all" data-section="introduction" id="introduction">
        <div class="section-wrapper with-margin">
          <div class="row">
            <div class="col-12 col-md-12 text-left ">
              <!-- title and description -->
            <div class="section-tittle paddig-container">
              <div class="cover-header-description-title2 scrolled">Welcome</div>
            </div>
              <div
                class="title-desc anim-4 letter-a paddig-container"
                v-html="d.consumer_section.short_description">
              </div>
                <div class="tour_host_box paddig-container" v-if="d.consumer_section.tour_host_photo">
                  <img class="tour_host_photo" :src="d.consumer_section.tour_host_photo"/>
                  <div class="tour_host_info">
                    <p class="tour_host_name" v-if="d.consumer_section.tour_host_name" v-html="d.consumer_section.tour_host_name"></p>
                    <p v-if="d.consumer_section.tour_host_position" v-html="d.consumer_section.tour_host_position"></p>
                  </div>
                </div>
              <span class="tour_host_box" v-if="!d.consumer_section.tour_host_photo"></span>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of grid list section -->
      <div class="section text-shadow-all" data-section="itinerary" id="itinerary">
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="section-tittle">
              <div class="cover-header-description-title2 scrolled">Itinerary</div>
              <div class="cover-header-description-title3 title3-itinerary" v-if="d && d.consumer_section">
                {{ d.consumer_section.trip_name }}
              </div>
              <div class="cover-header-description-title4">
                <i class="icon fa fa-calendar"></i>
                <span v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                <i class="fa fa-arrow-right"></i>
                <i class="icon fa fa-calendar"></i>
                <span v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}</span>
                <i v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)" class="fa fa-map-marker"></i>
                <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}</span>
              </div>
            </div>
            <div class="row row-random grid-media-aside-text fade-3">
              <!-- an item -->
              <div class="item col col-12 col-md-6 text-left" v-for="(day, index) in d.itineraries.days" :key="index">
                <div class="media-aside-text">
                  <div class="media-image">
                    <div class="media-image-content">
                    <img v-if="day.url_image_1200_725" :src="day.url_image_1200_725"/>
                    <img v-if="!day.url_image_1200_725" src="/landingpages/luxury-gold/img/day-img.jpg"/>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5 class="media-day">Day {{ day.startday }}</h5>
                    <h5 class="media-title" v-html="day.title"></h5>
                      <h6 class="media-date">
                        <i class="icon fa fa-calendar color-golden mr-2"></i>
                        <span v-if="day">{{ day.startdate | custom-date }}</span>
                      </h6>
                      <h6 v-if="day && day.locations && Array.isArray(day.locations)" class="media-location mt-1">
                        <i class="icon fa fa-map-marker color-golden mr-2"></i>
                        <span >{{ day.locations | custom-join('name') }}</span>
                      </h6>
                    <h6 class="media-details" data-toggle="modal" data-target="#modal-fullscreen" @click="dayScrollTo(index)"><span class="text">DETAILS</span></h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of description section -->
      <!-- <div class="section fullscreen-md-off bg-level-3 no-footer" data-section="inclusion" id="inclusion"> -->
      <div class="section fullscreen-md-off" data-section="inclusion" id="inclusion"
      v-if="Array.isArray(d.consumer_section.highlights) && d.consumer_section.highlights.length > 0 ||
        Array.isArray(d.consumer_section.whatsincluded) && d.consumer_section.whatsincluded.length > 0">
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="section-tittle">
              <div class="cover-header-description-title2 scrolled">Inclusions</div>
            </div>
            <div class="row">
              <div class="col-12 col-md-12 text-left">

                <div class="section-info white"
                v-if="Array.isArray(d.consumer_section.highlights) && d.consumer_section.highlights.length > 0">
                  <h1>Highlights</h1>
                  <div v-for="highlight in d.consumer_section.highlights" :key="highlight.id">
                    <h3 v-html="highlight.title"></h3>
                    <ul class="mb-4">
                      <li v-for="item in highlight.items" :key="item.id" v-html="item.items"></li>
                    </ul>
                  </div>
                </div>

                <div class="section-info white-gold  pr-4"
                v-if="Array.isArray(d.consumer_section.whatsincluded) && d.consumer_section.whatsincluded.length > 0">
                  <h1>What's Included</h1>
                  <div v-for="whatsinc in d.consumer_section.whatsincluded" :key="whatsinc.id">
                    <h3 v-html="whatsinc.title"></h3>
                    <ul class="mb-4">
                      <li v-for="item in whatsinc.items" :key="item.id" v-html="item.items"></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section section-register content-white text-shadow-all" data-section="map" id="map">
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="section-tittle">
              <div class="cover-header-description-title2 scrolled">Map</div>
            </div>
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc">
                  <p class="mb-5 mt-3">Map route is to be used as a guide for illustration purposes only, and does not represent the exact path taken.</p>
                </div>
              </div>

              <div class="col-12 col-md-12">
                <div class="section-maps">
                  <Map :locations="locationsVisited" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of description section -->
      <div class="section fullscreen-md-off" data-section="prices" id="prices">
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="section-tittle">
              <div class="cover-header-description-title2 scrolled">Pricing</div>
            </div>
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="section-info white white-gold table_pricing">
                  <div class="row">
                    <div class="col-12 col-md-6 anim">
                      <div class="title-desc amount-price" v-if="d && d.consumer_section">
                        <p class="display-5 anim-2">Twin Share Price</p>
                        <h2 class="display-5 anim-2 text-center pb-0">{{ d.consumer_section.twinshare_price }}</h2>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 anim fluid contact-info-right">
                      <div class="contact-us-box">
                        <div class="title-desc amount-price" v-if="d && d.consumer_section">
                          <p class="display-5 anim-2">Single Supplement Price</p>
                          <h2 class="display-5 anim-2 text-center pb-0">{{ d.consumer_section.single_supp_price }}</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p class="terms text-shadow-all">View <a href="#" @click.prevent="toggleTermsAndConditionsModal">Terms and Conditions</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of contact section -->
      <div class="section text-shadow-all section-contact  content-white " data-section="contact" id="contact" >
        <div class="section-wrapper with-margin">
          <div class="section-content paddig-container">
            <div class="row">
              <div class="col-12 col-md-6 anim contact-info contact-info-left ">
                <div class="section-tittle">
                  <div class="cover-header-description-title2 scrolled text-center">Contact us
                  </div>
                </div>
                 <div class="pt-4 text-center">
                   <h3 class="pt-4" v-if="!d.consumer_section && !d.consumer_section.company_logo">
                      Contact your Travel Agent!
                   </h3>

                    <p class="pt-4 pb-4 text-center" v-if="!d.consumer_section.call_action">
                      Please send a message.
                    </p>

                    <p class="contact-info-call" v-if="d.consumer_section.call_action" v-html="d.consumer_section.call_action"></p>
                    <img class="tour_host_logo" v-if="d.consumer_section.company_logo" :src="d.consumer_section.company_logo"/>
                  </div>
              </div>

              <div class="col-12 col-md-6 anim contact-info contact-info-right fluid contact-border-left">
                <div class="contact-us-box">
                <div class="section-tittle">
                  <div class="cover-header-description-title2 scrolled">Message us Directly
                  </div>
                </div>
                  <form  @submit.prevent="sendContactForm">
                    <div class="form-group ">
                      <input class="form-control-white" type="text" required placeholder="Name" v-model="name" :disabled="isSending">
                    </div>
                    <div class="form-group ">
                      <input class="form-control-white" type="text" required placeholder="Email" v-model="email" :disabled="isSending">
                    </div>
                    <div class="form-group ">
                      <textarea class="form-control-white" type="text" required placeholder="How can we assist you with this group?" cols="10" rows="10" v-model="description" :disabled="isSending"></textarea>
                    </div>
                    <div class="form-group form-success-gone mb-0 d-flex justify-content-center align-items-center">
                      <div v-if="isCompleted" class="mr-3">{{ message }}</div>
                      <button class="btn btn-outline-white-gold form-success-gone mb-0" type="submit" :disabled="isSending">
                        <strong class="text" v-if="!isSending">Send</strong>
                        <strong class="text" v-else>Sending</strong>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Begin of footer section -->
      <footer>
          <div class="footer-left text-shadow-all">
            <ul class="social">
            <li>
              <a  @click="scrollMeTo('home')">
                <i class="icon-arrow-up"></i>
              </a>
            </li>
              <li>
                <a @click="scrollMeTo('itinerary')">
                  <i class="icon fa fa-globe"></i>
                </a>
              </li>
              <li>
                <a @click="scrollMeTo('contact')">
                  <i class="icon fa fa-phone"></i>
                </a>
              </li>
            </ul>
          </div>
        <div class="section-wrapper padding-footer">
          <div class="powered-by-text">
            Powered by <img src="/landingpages/luxury-gold/img/logo-itp.png" width="80"> All rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}
          </div>
        </div>
      </footer>
    </main>

    <!-- Modal -- TERMS AND CONDITIONS -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-terms-and-conditions-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalTermsAndConditionsToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalTermsAndConditionsToggle">
        <div class="section-header">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleTermsAndConditionsModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content  ">
            <div class="modal-body">
              <div class="title-desc"><h3 class="h2 color-golden pt-4 text-center">Terms & Conditions</h3></div>
              <div
                class="title-desc anim-4 paddig-container scrollable "
                v-html="d.consumer_section.terms_conditions">
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- Finish Modal-- TERMS AND CONDITIONS -->

    <!-- Modal Fullscreen -- DAYS-->
    <div
      class="modal modal-fullscreen fade modalDays animated fadeIn"
      id="modal-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
      :class="{ 'show': isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle">
      <div class="section-header">
        <div class="label-logo">
          <img v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id" class="light-logo" src="/landingpages/luxury-gold/img/logo.png" alt="Logo">
          <img v-else class="light-logo" src="/landingpages/luxury-gold/img/logo.png" alt="Logo">
        </div>
        <button
          type="button" class="close" data-dismiss="modal" aria-hidden="true"
          @click="toggleModal"><i class="fa fa-times"></i></button>
      </div>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">

            <div
              class="col-md-12 p-0 section-day p active"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days" :key="index">
              <div class="row">
                <div class="col-md-6 cover-image">
                  <img v-if="day.url_image_1600_900" :src="day.url_image_1600_900"/>
                  <img v-if="!day.url_image_1600_900" src="/landingpages/luxury-gold/img/day-img.jpg"/>
                </div>
                <div class="col-md-6 section-text">
                  <div class="align-vcenter">
                    <h1>Day {{ index + 1}}</h1>
                    <p class="subtittle" v-html="day.title"></p>
                    <p class="date">
                      <i class="icon fa fa-calendar mr-1"></i>
                      <span class="text-uppercase" v-if="day">{{ day.startdate | custom-date }}</span>
                    </p>
                    <p class="location mt-2" v-if="day && day.locations && Array.isArray(day.locations)" >
                      <i class="fa fa-map-marker mr-2"></i>
                      <span>{{ day.locations | custom-join('name') }}</span>
                    </p>
                    <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">ACCOMMODATION:</strong>
                      <span v-html="day.accommodation"></span>
                    </p>
                  </div>
                  <footer class="section-footer scrolldownDay nextday"
                  v-if="index != Object.keys(d.itineraries.days).length - 1">
                    <a class="down" @click="scrollMeDay(`day${index+1}`)">
                      <span class="txt">DAY {{ Number(day.startday) + 1 }}</span>
                    </a>
                  </footer>
                  <footer class="section-footer scrolldownDay nextday" v-else>
                    <a class="down" @click="scrollMeDay('day0')">
                      <span class="txt">DAY 1</span>
                    </a>
                  </footer>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- Finish Modal Fullscreen -- DAYS-->
  </div>
</template>
